module.exports = __webpack_public_path__ + "media/images/icon_new_member_register-7cf27e59a141c64956dfcf7c0f0d0721.png";